<template>    
    <mainlist
        color="#fff"
        :items="entities"
        :list="list"
    ></mainlist>
</template>
<script>
    import { mapGetters } from 'vuex';    
    import mainlist from '../components/lists/MainList.vue';     
    export default {   
    
    props: [
        
    ],
    components:{
        mainlist: mainlist
    },
    data() {
        return {  
           list:"entities"
                    
        }
    },
    computed: {
        ...mapGetters({            
            entities: 'entities/entities'
        }),
        
    },
    methods: {
        
    },
    mounted() {
        this.$store.dispatch('entities/getAll')
    }
    
    
}
</script>